/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_On_Hold_Amendment_PendingInputs */

const en_orders_on_hold_amendment_pending = /** @type {(inputs: Orders_On_Hold_Amendment_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On Hold - Amendment Payment Pending`)
};

const es_orders_on_hold_amendment_pending = /** @type {(inputs: Orders_On_Hold_Amendment_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En espera - pago de enmienda pendiente`)
};

/**
* | output |
* | --- |
* | "On Hold - Amendment Payment Pending" |
*
* @param {Orders_On_Hold_Amendment_PendingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_on_hold_amendment_pending = /** @type {((inputs?: Orders_On_Hold_Amendment_PendingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_On_Hold_Amendment_PendingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_on_hold_amendment_pending(inputs)
	return es_orders_on_hold_amendment_pending(inputs)
});